import React from 'react';
import { genURL } from '../../../_getjson';
import axios from 'axios';
import { DataGrid, GridToolbarQuickFilter, GridToolbar, } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

export default function ListData(props) {

    const {
        multiselect
    } = props
    const [loading, setLoading] = React.useState(true)
    const [data, setData] = React.useState([])
    const [selectionModel, setSelectionModel] = React.useState([]);

    // const rows = [
    //     { id: 1, code: 'Hello', name: 'World' },
    //     { id: 2, code: 'DataGridPro', name: 'is Awesome' },
    //     { id: 3, code: 'MUI', name: 'is Amazing' },
    // ];

    React.useEffect(() => {
        getSiteData();
        return () => {
        }
    }, [])

    const getSiteData = async () => {
        let rows = []
        setLoading(true)
        let url = `CSUNIT/All?`


        await axios.get(genURL(url)).then(e => {
            for (let index = 0; index < e.data.length; index++) {
                rows.push({ id: index + 1, code: e.data[index].CODE, name: e.data[index].MYNAMETH })
            }
        })
        await console.log(rows);
        await setLoading(false)
        await setData(rows)


    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 90, hide: true },
        {
            field: 'code',
            headerName: 'Unit Code',
            width: 30,
            editable: false,
            flex: 1
        },
        {
            field: 'name',
            headerName: 'Unit Name',
            width: 150,
            editable: false,
            flex: 1
        },
    ];

    const handleDoubleClick = (e) => {
        // console.log(selectionModel); 
        // f
        let result = []
        if (selectionModel.length > 0) {
            result = data.filter((elem) => {
                return selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        } else {
            result.push(e.row)
        }
        props.resultData(result)
    }

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                }}
            >
                <GridToolbarQuickFilter />
            </Box>
        );
    }


    return (
        <>
            <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                {loading == true ? "กำลังโหลด..." :
                    <DataGrid
                        rows={data}
                        columns={columns}

                        sx={{
                            fontFamily: "Customfont !important"
                        }}
                        disableColumnFilter
                        disableColumnSelector
                        disableDensitySelector
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                            // filter: {
                            //     filterModel: {
                            //         items: [],
                            //         quickFilterValues: ['quick', 'filter'],
                            //     },
                            // },
                        }}
                        pageSizeOptions={[10]}

                        checkboxSelection={multiselect}
                        disableSelectionOnClick
                        onSelectionModelChange={(newSelectionModel) => {
                            setSelectionModel(newSelectionModel);
                        }}
                        selectionModel={selectionModel}
                        onRowDoubleClick={e => handleDoubleClick(e)}
                        //  onRowClick={e => handleClick(e)}
                        components={{ Toolbar: QuickSearchToolbar }}
                    />}
            </Box>
        </>
    )

}
ListData.propTypes = { multiselect: PropTypes.bool, }
ListData.defaultProps = {
    multiselect: false
};